/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Fact_AreaInputs */

const cs_ebr_fact_area = /** @type {(inputs: Ebr_Fact_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha`)
};

const en_ebr_fact_area = /** @type {(inputs: Ebr_Fact_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area`)
};

/**
* | output |
* | --- |
* | "Area" |
*
* @param {Ebr_Fact_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_fact_area = /** @type {((inputs?: Ebr_Fact_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Fact_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_fact_area(inputs)
	return cs_ebr_fact_area(inputs)
});